import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ArticleCard from "@/components/base/ArticleCard";
import { articles } from "@/mocks/articles";
import { organizationSchema, breadcrumbSchema } from "@/lib/seoData";

const categoryTabs = ["全部", ...Array.from(new Set(articles.map((a) => a.category)))];

export default function Articles() {
  const [active, setActive] = useState("全部");
  const list = useMemo(
    () => (active === "全部" ? articles : articles.filter((a) => a.category === active)),
    [active],
  );

  const jsonLd = [
    organizationSchema,
    breadcrumbSchema([
      { name: "首页", path: "/" },
      { name: "番剧资讯", path: "/articles" },
    ]),
  ];

  return (
    <Layout>
      <Seo
        title="番剧资讯 - 动漫网新番导览 / 国漫盘点与追番攻略"
        description="动漫网番剧资讯栏目，汇集新番导览、国漫盘点、日漫入坑攻略与治愈系推荐，为你的动漫之旅提供灵感与深度内容。"
        keywords="动漫网,动漫网番剧资讯,动漫网新番索引,动漫网国漫专区,动漫网日漫检索,动漫网漫画分类大全"
        canonical="/articles"
        jsonLd={jsonLd}
      />

      <section className="bg-background-100 pt-24 pb-14 md:pb-20">
        <div className="mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: "番剧资讯", path: "/articles" }]} />
          <div className="mt-4">
            <span className="font-heading text-sm text-primary-600">动漫网番剧资讯</span>
            <h1 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">追番资讯 · 深度盘点</h1>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
              新番导览、国漫盘点与追番攻略，为你的动漫之旅提供灵感。
            </p>
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-10">
        <div className="mx-auto px-4 md:px-6">
          <div className="flex flex-wrap items-center gap-2 rounded-full border border-background-200/70 bg-background-100 p-1 w-fit">
            {categoryTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                  active === tab ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-50 hover:text-foreground-950"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/categories"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              顺便看看全部动漫
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}